<template>
  <div class="renewal-center d_flex flex_direction_col">
    <!-- 状态 -->
    <!-- <div :class="`pro-state ${stateColor(itemDetail.state)}`">
      {{stateDesc}}
    </div> -->
    <div class="detail_main_info d_flex justify_content_sb flex_direction_col">
      <!-- block-1 -->
      <div class="main_block_1">
        <!-- 时间文本 -->
        <div class="state-time-line c_1A1A1A" v-if="stateTimeDesc(itemDetail.state)">
          <div>
            <span  class="state-time-desc cell_label fz12"
              >{{ stateTimeDesc(itemDetail.state) }}：</span
            >
            <!-- 倒计时 -->
            <div class="state-time-countdown" v-if="isShowCountDown">
              <span v-if="d" class="time-i">
                <em class="time-num fz24 font_w_bold">{{ d }}</em
                >天</span
              ><span  class="time-i">
                <em class="time-num fz24 font_w_bold">{{ h }}</em
                >时</span
              ><span class="time-i"
                ><em class="time-num fz24 font_w_bold">{{ m }}</em
                >分</span
              ><span>
                <em class="time-num fz24 font_w_bold">{{ s }}</em
                >秒</span
              >
            </div>
            <!-- 时间文本 -->
            <span v-else class="state-time c_1A1A1A font_w_bold">{{ stateTime }}</span>
          </div>
        </div>
        <!-- 项目展示价格（成交价，当前价） -->
        <div class="price_w">
          <div class="cell_row d_flex">
            <span class="cell_label fz12 c_1A1A1A" >{{priceDesc(itemDetail.state)}}</span>
            <span class="fz12 c_CF3342">
              <el-tooltip effect="dark" :content="amountTran(itemDetail.project.price)" placement="top">
                <em class="fz24 font_w_bold" style="margin: 0 5px">{{
                  formatMoney(itemDetail.project.price)
                }}</em>
              </el-tooltip>
            </span>
            <span class="fz12 c_CF3342"
              >{{ itemDetail.priceUnitDesc }}
              </span>
            <!-- <span v-if="itemDetail.priceUnit === 'zongjia'" class="fz12 c_CF3342"
              >（总价）
            </span> -->
          </div>
        </div>
      </div>

      <!-- block-2 -->
      <div class="main_block_2 flex_direction_col bc_e6e6e6">
        <div class="block-outer" >
          <div class="block-inner">
            <!-- 备注 -->
            <div class="state-remark" v-if="isShowStateRemark">
              {{ stateRemark }}
            </div>
          </div>
        </div>
      </div>

      <!-- block-3 -->
      <div class="main_block_3 d_flex fz12">
        <span class="cell_i c_808080"
          ><em class="fz16 c_1A1A1A">{{ itemDetail.statis.onlookerCnt || 0}}</em
          >次围观</span
        >

      </div>
    </div>
    <!-- block-4 -->
    <div class="main_block_4 fz12 c_808080">
      <div class="cell_row d_flex flex_wrap">
        <div class="" style="flex: 0.33">

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auction_checkNotice } from "@/api/portal";
import { project_beat_time } from "@/api/action";
import { mapGetters, mapActions } from "vuex";
import {
  formatDate,
  tranTimeFormat,
  confirmCallBack,
  numTurnText,
  uuid,
  numTranFloat,
  amountTran
} from "@/utils";
import Cookies from "js-cookie";

import { MySocket } from "@/utils/webSocket";
import {TradeModeText} from '@/enums'

export default {
  props: {
    itemDetail: {
      type: Object,
      default: () => {},
    },
    reqInfoTime: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      diffTime: null, //时间差值（用于计算倒计时）
      countDownTimer:null,
      pollIntervalTimer:null,
      pollInterval: 1000 * 30, //轮询间隔
    };
  },
  computed: {
    ...mapGetters(["isLogin", "cmsNoticeNode", "userinfo", "priceUnitKey",'stateAllKey']),
    amountTran:()=>amountTran,
    //格式化时间
    formatDate: function () {
      return function (date, fmt) {
        if (!date) return "";
        return formatDate(new Date(date), fmt);
      };
    },
    tranTimeFormat() {
      return function (dateStr) {
        if (!dateStr) return "";
        return dateStr.replace(/-/g, "/");
      };
    },
    //格式化金额（小数点）
    formatMoney: function () {
      return function (num) {
        return Number(num).toLocaleString();
      };
    },
    // 价格描述
    priceDesc(){
      return function(state){
        let text = ''
        switch(state){
          case 4: text = '成交价格：';break;
          default: text = '挂牌价格：';break;
        }
        return text
      }
    },
    // 状态
    stateDesc(){
      return this.stateAllKey[this.itemDetail.project.tradeMode][this.itemDetail.state]
    },
    // 状态颜色
    stateColor(){
      return function(state){
        let text = "";
        switch (state) {
          case 6: text = "bc_EF3946";break;
          case 1:
          case 3:
          case 4:
          case 7:
          case 8:
          case 10: text = "bc_808080";break;
        }
        return text;
      }
    },
    // 状态时间文本
    stateTimeDesc() {
      return function(state){
        let text = "";
        switch (state) {
          case 4:
          case 7:
          case 8:
          case 10: text = '结束时间';break;
          case 5: text = '';break
          case 6: text = "距结束";break;
        }
        return text;
      }
    },
    // 状态时间线
    stateTime(){
      let text = ''
        switch(this.itemDetail.state){
          case 6: text = this.itemDetail.applyEndTime;break;
          case 4:
          case 5:
          case 7:
          case 8:
          case 10: text = this.itemDetail.stateEndTime;break;
        }
        return text
    },
    // 状态备注
    stateRemark() {
      let text = "";
      switch (this.itemDetail.state) {
        case 3:
          text = '待合同签署';break;
        case 6:
          text = '待意向人确认';break;
        case 4:
          text = '项目已交易';break;
        default:
          text = this.itemDetail.stateRemark;
      }
      return text;
    },
    // 是否显示状态备注
    isShowStateRemark() {
      return [3, 4, 6, 7, 8, 10].includes(this.itemDetail.state);
    },
    tradeModeText(){
      return TradeModeText[this.itemDetail.project.tradeMode]
    },
    // 是否显示倒计时
    isShowCountDown(){
      return [6].includes(this.itemDetail.state)
    },
    // 天
    d(){
      return Math.floor(this.diffTime / (1000 * 60 * 60) / 24)
    },
    // 时
    h(){
      return Math.floor(this.diffTime / (1000 * 60 * 60) % 24)
    },
    // 分
    m(){
      return Math.floor(this.diffTime / (1000 * 60) % 60)
    },
    // 秒
    s(){
      return Math.floor(this.diffTime / (1000) % 60)
    },
    // 项目是否已结束
    isEnd() {
      return [4, 7, 8, 10].includes(this.itemDetail.state);
    },
    // socket订阅地址
    subscribeUrl() {
      return "/topic/auction/" + this.itemDetail.project.projectNo;
    },
  },
  watch: {
    diffTime(n){
      if(n <= 0){
        this.diffTime = 0
        clearInterval(this.countDownTimer)
      }
    },
    isEnd: {
      handler(n) {
        if (n) {
          clearInterval(this.countDownTimer);
          clearInterval(this.pollIntervalTimer);
        } else {
          this.initWebsocket();
        }
      },
      immediate:true
    },
  },

  async created() {
    if(this.isShowCountDown){
      this.computedDiffTime()
      this.startCountDown()
      this.startPollInterval()
      this.pageVisibilitychange()
    }
  },
  mounted() {
  },
  methods: {
    ...mapActions({
      initNoticeNode: "cache/initNoticeNode",
    }),
    // 缴纳保证金报名 click
    onApplyClick(){
      if(!this.isLogin) {
        this.$router.push({name:'login',query:{
          returnUrl:this.$route.fullPath
        }})
        return
      }
      this.$router.push({
        name:'tradeApply',
        query:{
          projectNo:this.itemDetail.project.projectNo,
          tradeMode:this.itemDetail.project.tradeMode
        }
      })
    },
    // 开启倒计时
    startCountDown(){
      clearInterval(this.countDownTimer)
      this.countDownTimer = setInterval(() => {
        if( this.diffTime < 0){
          clearInterval(this.countDownTimer)
        }
        this.diffTime -= 1000
      }, 1000);
    },
    // 计算时差
    computedDiffTime(){
      this.diffTime = this.itemDetail.countdownTime
    },
    // 校准倒计时
    async checkCountDown(){
      let {data} = await project_beat_time({
        projectNo: this.itemDetail.projectNo,
        uid: uuid(13)
      });
      this.diffTime = data.countdownTime
      this.startCountDown()
    },
    // 开启轮询
    startPollInterval(){
      clearInterval(this.pollIntervalTimer)
      this.pollIntervalTimer = setInterval(async() => {
        this.checkCountDown()
      }, this.pollInterval);
    },
    // 页面可见 change
    pageVisibilitychange(){
      window.addEventListener('visibilitychange',this.handlePage)
    },
    // 处理页面显示
    handlePage(){
      if (!document.hidden) { // 状态判断：显示（切换到当前页面）
        if(this.isShowCountDown){
          this.checkCountDown();
        }
      }
    },
    // 初始websocket
    initWebsocket() {
      this.webSocket?.doUnSubscribes();
      this.webSocket = new MySocket({
        url: process.env.VUE_APP_WS_API,
      });
      this.webSocket.doConnect().then(() => {
        this.webSocket.doSubscribe(this.subscribeUrl, (msg) => {
          this.socketRes = JSON.parse(msg.body);
          this.onHandleWsEvent(this.socketRes.event);
        });
      });
      window.addEventListener("online", this.handleOnline);
      window.addEventListener("offline", this.handleOffline);
    },
    // 处理竞拍socket响应的事件
    onHandleWsEvent(eventKey) {
      switch (eventKey) {
        case "stateChange":
          this.handleStateChange();
          break;
        case "delayed":
          this.handleDelayed();
          break;
        case "end":
          this.handleEnd();
          break;
      }
    },
    //处理-项目状态
    handleStateChange() {
      this.itemDetail.state = this.socketRes.state - 0;
      this.computedDiffTime(this.socketRes.countdownTime);
      this.startCountDown();
    },
    //处理-项目延时
    handleDelayed() {
      this.computedDiffTime(this.socketRes.countdownTime);
      this.startCountDown();
    },
    //处理-项目结束
    handleEnd() {
      this.itemDetail.state = this.socketRes.state - 0;
      this.itemDetail.stateEndTime = this.socketRes.endTime;
      this.itemDetail.remark = this.socketRes.remark;
      this.itemDetail.stateRemark = this.socketRes.remark;
    },
  },
  destroyed() {
    this.webSocket?.doUnSubscribes();
    clearInterval(this.countDownTimer);
    clearInterval(this.pollIntervalTimer);
    window.removeEventListener("visibilitychange", this.handlePage);
  },
};
</script>

<style lang="scss" scoped>
.renewal-center {
  overflow: hidden;
  position: relative;
  width: 440px;
  margin: 0 10px;
  border: 1px solid #e6e6e6;
  .pro-state {
    position: absolute;
    top: 0;
    right: 0;
    width: 100px;
    height: 100px;
    line-height: 170px;
    transform: translate(50px, -50px) rotateZ(45deg);
    text-align: center;
    color: #fff;
    font-size: 12px;
  }
}
.detail_main_info {
  .state-time-line{
    margin: 10px 0;
    .state-time-countdown{
      display: inline-block;
    }
  }
  .price_w {
    margin: 10px 0;
    & > span {
      &:first-child {
        margin: 0 18px 0 0;
      }
    }
  }
  .state_end_desc {
    margin: 0 0 12px 0;
    & > img {
      margin: 0 14px 0 0;
    }
  }

  .main_block_1 {
    position: relative;
    min-height: 100px;
    padding: 10px;
    box-sizing: border-box;
    .cell_label {
      display: inline-block;
      min-width: 60px;
      white-space: nowrap;
      text-align: right;
    }
    .time-i {
      margin: 0 4px 0 0;
    }
    .time-num {
      margin: 0 5px;
    }
    .tradeMode-text{
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 12px;
      background-color: #0983cc;
      color: #fff;
      padding: 4px 10px;
    }
  }
  .main_block_2 {
    height: 140px;
    .bid_text {
      margin: 0 20px;
      line-height: 36px;
    }
    .block-outer{
      display: flex;
      justify-content: center;
      height: 100%;
      .block-inner{
        display: flex;
        align-items: center;
        .state-remark {
          color: #666;
        }
      }
    }
  }
  .main_block_3 {
    .cell_i {
      height: 32px;
      line-height: 32px;
      flex: 1;
      text-align: center;
      border-bottom: 1px solid #e6e6e6;
      border-top: 1px solid #e6e6e6;
      &:last-child {
        border-left: 1px solid #e6e6e6;
      }
    }
  }
}
.cell_row {
  margin: 10px 0;
  align-items: baseline;
}
.main_block_4 {
  padding: 0 20px;
  .cell_row {
    margin: 10px 0;
  }
}
</style>
